import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getDiscussionTopics = createAsyncThunk("discussionHub/getDiscussionTopics", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetDiscussionTopics`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getDiscussionTags = createAsyncThunk("discussionHub/getDiscussionTags", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetDiscussionTags`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getTopicPosts = createAsyncThunk("discussionHub/getTopicPosts", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetTopicPosts`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getPost = createAsyncThunk("discussionHub/getPosts", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetPosts`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getPostDetails = createAsyncThunk("discussionHub/getPostDetails", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetPostDetails`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const addPost = createAsyncThunk("discussionHub/addPost", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/AddPost`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const postLike = createAsyncThunk("discussionHub/postLike", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/PostLike`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const postShare = createAsyncThunk("discussionHub/postShare", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/PostShare`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const postReply = createAsyncThunk("discussionHub/postReply", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/PostReply`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const postBookmark = createAsyncThunk("discussionHub/postBookmark", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/PostBookmark`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});